<!-- src/components/LayerPage5.vue -->
<template>
  <div class="whole-container">
    <div class="header">
      <h1> Bulk Transcriptomics of Endometrium (WOI) </h1>
      <div class="function_description">
          <p> Bulk RNA sequencing was performed on endometrial biopsies LH-timed to the WOI from women with sonographic features of adenomyosis (n=10) and controls (n=10) using the Illumina NovaSeq 6000 platform. Data was from the study of Prašnikar et al. (DOI: 10.1186/s12958-021-00871-5). </p>
        </div>
    </div>
    <GeneChoose uniqueId="function_5" function_name="function_5" description="Enter a gene to explore its expression in the endometrium of WOI adenomyosis"></GeneChoose>
    <!-- Your content for Page 1 goes here -->
  </div>
</template>

<script>
import GeneChoose from '@/components/GeneChoose.vue';
export default {
  components: {
    GeneChoose,
},
  name: 'PageFour'
}
</script>